import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/contact";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";

export default function ContactView({
  goBack,
  name,
  email,
  message,
  onChange,
  onChangeMessage,
  isDisabled,
  submit,
  isLoading,
  isVisibleModal,
  error,
  toggleModal,
}: PropsView) {
  const renderModal = () => (
    <div className="fixed flex flex-1 top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 justify-center items-start text-black h-full min-h-screen">
      <div className="relative w-full max-w-[calc(480px)] max-h-full mt-[calc(100px)]">
        <div className="relative bg-white rounded-2xl shadow p-5">
         <div className="w-full flex flex-col items-center pb-3">
            <p className="self-center text-lg mt-3 font-bold mb-3">Atenção!</p>
            <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
            <p className="text-sm mt-2 text-center">{error ? "Não foi possível enviar sua dúvida. Tente novamente mais tarde!" : "Dúvida enviada com sucesso. Em breve entraremos em contato para te ajudar!"}</p>
            <button type="button" onClick={toggleModal} className="mt-3 mb-3 bg-black border p-2 rounded-lg h-[calc(60px)] text-white w-full">Ok</button>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header
        title="Entre em contato"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-1 z-10 p-2 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className={`w-full`}>
            <h2 className="text-black mt-6 font-bold text-2xl">Ok!</h2>
            <h3 className="text-gray-600 mt-1 text-base">Qual sua dúvida?</h3>
            <input
              value={name as string}
              required
              onChange={onChange}
              type="text"
              name="name"
              placeholder="Nome completo"
              className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
            />
            <input
              value={email as string}
              required
              onChange={onChange}
              type="text"
              name="email"
              placeholder="E-mail"
              className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
            />
            <textarea
              value={message as string}
              required
              onChange={onChangeMessage}
              name="message"
              placeholder="Mensagem"
              className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-[calc(160px)]"
            />
          </div>
          <Button
            title="Enviar"
            type="submit"
            onClick={submit}
            isDisabled={isDisabled}
          />
        </article>
      </main>
      {isVisibleModal && renderModal()}
      {isLoading && <Loading />}
    </div>
  );
}
